import { useQuery } from "@tanstack/react-query";

import type { MemberPricingContext } from "@/utils/algoliaCatalog";
import { getShopMemberPricing } from "api/methods";

/**
 * Which member price a catalog card shows for the patient (`GET /shop/member-pricing`). It does not block the
 * page: cards render with their price at once and member prices fill in when this arrives.
 */
export const useMemberPricingContext = (): MemberPricingContext | undefined => {
  const { data } = useQuery({ ...getShopMemberPricing.keyed(), staleTime: 1000 * 60 });
  return data ?? undefined;
};
